import { APIPostRequest } from "@/utils/requests";
import { getApiClient } from "@punchup/utils/apiRegistry";
import { toast } from "@/shadcn/ui/use-toast";

export async function loginAsUser({
  userId,
  email,
}: {
  userId?: string;
  email?: string;
}) {
  try {
    await APIPostRequest("/api/v2/internal/login-as", {
      userId,
      email,
    });
  } catch (error) {
    toast({
      title: "Error",
      variant: "destructive",
      description: (error as Error).message,
    });
    throw error;
  }

  toast({
    title: "Success",
    variant: "success",
    description: `Logged in!`,
  });
  window.location.href = "/profile";
  return true;
}

/**
 * Seconds the browser's login-as impersonation has left by the server's
 * clock, or null when there is none.
 */
export async function fetchLoginAsSecondsLeft(): Promise<number | null> {
  const { data } = await getApiClient().get<{
    data: { secondsLeft: number } | null;
  }>("/api/v2/internal/login-as/status");
  return data?.secondsLeft ?? null;
}
